<section class="automatic-data" aria-label="Dados do cadastro da empresa">
  <header class="automatic-data__header">
    <span class="automatic-data__title">
      <i class="pi pi-building"></i>
      Dados do cadastro da empresa
    </span>
    <span class="automatic-data__hint">
      {{
        frozen()
          ? 'Congelados quando o contrato foi finalizado.'
          : 'Entram no texto como estão no cadastro; não são editados aqui.'
      }}
    </span>
  </header>

  @if (loading()) {
    <app-loading />
  } @else {
    @if (data(); as company) {
      <dl class="automatic-data__list">
        <div>
          <dt>Razão social</dt>
          <dd>{{ company.legalName || '-' }}</dd>
        </div>
        <div>
          <dt>CNPJ</dt>
          <dd>{{ (company.cnpj | vaultMaskCnpj) || '-' }}</dd>
        </div>
        <div class="automatic-data__wide">
          <dt>Endereço</dt>
          <dd>{{ address() || '-' }}</dd>
        </div>
        <div class="automatic-data__wide">
          <dt>Representante legal</dt>
          <dd>
            @if (company.representativeName) {
              {{ company.representativeName }}
              @if (company.representativePosition) {
                · {{ company.representativePosition }}
              }
              @if (company.representativeEmail) {
                · {{ company.representativeEmail }}
              }
            } @else {
              -
            }
          </dd>
        </div>
      </dl>
    }

    @if (missingList().length) {
      <div class="automatic-data__missing" role="status">
        <i class="pi pi-exclamation-triangle"></i>
        <span>
          <strong>Falta no cadastro:</strong> {{ missingList().join(', ') }}. Enquanto faltar, a
          variável fica destacada em amarelo no texto e no PDF.
          @if (fixLabel() && !frozen()) {
            <button type="button" class="automatic-data__fix" (click)="fix.emit()">
              {{ fixLabel() }}
            </button>
          }
        </span>
      </div>
    }
  }
</section>
